<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12 ">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">전자계약</h3>
              <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약을 관리할 수 있습니다.</h5>
            </div>
          </div>
        </div>
        <div class="small-header">
          신규 계약 추가하기
        </div>
        <a-row type="flex" align="middle" :gutter=30 justify="center">
          <a-col class="col-sm-12 col-xs-12 contract-container">
            <div class="contract-title">
              {{ pageTitle }}
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">매수인 (고객)</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="고객 상호"
                    :is-required="true"
                    :class="'fixed-btn-110 mobile-wrap'"
                    :errorIds="['company-name-error']"
                >
                  <div class="disabled-event-wrap">
                    <input
                        ref="companyName"
                        type="text"
                        class="ant-like-input"
                        :disabled="!directInputClientName"
                        v-model="clientData.companyName"
                        placeholder="거래처 검색을 통해 입력해주세요"
                    />
                    <div
                        v-if="!directInputClientName"
                        class="fire-event-container"
                        @click="uiHandler.handleModal.client.show"
                    />
                  </div>
                  <div class="checkbox-container">
                    <a-checkbox v-model:checked="directInputClientName" @change="uiHandler.checkDirectInputClientName">직접입력</a-checkbox>
                  </div>
                  <button class="btn-darkgray btn-hover"
                          :disabled="directInputClientName"
                          @click="uiHandler.handleModal.client.show">
                    거래처 검색
                  </button>
                </contract-item-wrap>

                <contract-item-wrap
                    label="주소"
                    :is-required="true"
                    :class="'fixed-btn-110 mobile-wrap'"
                    :errorIds="['address-error']"
                >
                  <div class="disabled-event-wrap">
                    <textarea
                        maxlength="67"
                        type="text"
                        v-model="clientData.address"
                        ref="address"
                        placeholder="주소 검색을 통해 입력해주세요"
                        class="address ant-like-input"
                        style="width: 100%;"
                    />
                  </div>
                  <div class="button-wrapper">
                    <button class="btn-darkgray btn-hover" @click="uiHandler.searchAddress">
                      주소 검색
                    </button>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="대표자 정보"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['ceo-name-error', 'ceo-birthday-error']"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="이름 입력"
                        ref="ceoName"
                        v-model="clientData.ceo.name"
                        @input="uiHandler.handleRemoveError('ceoName', 'ceo-name-error')"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="연락처"
                    :is-required="true"
                    :errorIds="['mobile-error']"
                >
                  <div class="input-area icon" ref="companyMobileNumber">
                    <i class="fa-solid fa-mobile-screen"/>
                    <input
                        class="full-width"
                        type="text"
                        maxlength="13"
                        placeholder="010-0000-0000"
                        v-model="clientData.contact.mobile"
                        @input="uiHandler.changeMobileNumber(true)"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>

            <div class="contract-section-wrap">
              <div class="contract-section-title">계약 내용</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="계약일"
                    :is-required="true"
                    :errorIds="['contract-date-error']"
                >
                  <div class="custom-calendar-wrap single" ref="contractDate">
                    <a-date-picker
                        type="date"
                        class="contract-item"
                        placeholder="계약 일자"
                        v-model:value="contractDate"
                        :locale="locale"
                        :bordered="false"
                        @change="uiHandler.handleContractDate"
                    />
                  </div>
                </contract-item-wrap>

                <contract-item-wrap
                    label="생년월일"
                    :is-required="true"
                    :errorIds="['client-birth-date-error']"
                >
                  <div class="custom-calendar-wrap single" ref="clientBirthDate">
                    <a-date-picker
                        type="date"
                        class="contract-item"
                        placeholder="생년월일을 선택해주세요"
                        v-model:value="clientBirthDate"
                        :locale="locale"
                        :bordered="false"
                        :disabledDate="disabledFutureDate"
                        @change="handleBirthDateChange"
                        format="YYYY-MM-DD"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>

            <div class="contract-section-wrap">
              <div class="contract-section-title">영업담당자 확인</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="지점 및 성명"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['dept-error', 'person-in-charge-error']"
                >
                  <div class="input-area name" ref="dept">
                    <a-select v-if="directInputClientName"
                              :value="selectedDept"
                              show-search
                              style="width: 100%;"
                              @change="val => {
                                personInCharge.dept = val
                                selectedDept = val
                              }"
                              placeholder="지점을 선택해 주세요."
                              :notFoundContent="null"
                              :options="deptNames"></a-select>
                    <input
                        v-else
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="지점명 입력"
                        v-model="personInCharge.dept"
                        @input="uiHandler.handleRemoveError('dept', 'dept-error')"
                    />
                  </div>
                  <div class="input-area name" ref="personInChargeName">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="이름 입력"
                        v-model="personInCharge.name"
                        @input="uiHandler.handleRemoveError('personInChargeName', 'person-in-charge-error')"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="연락처"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['person-in-charge-mobile-error']"
                >
                  <div class="input-area icon" ref="personMobileNumber">
                    <i class="fa-solid fa-mobile-screen"/>
                    <input
                        type="text"
                        maxlength="13"
                        placeholder="010-0000-0000"
                        v-model="personInCharge.mobile"
                        @input="uiHandler.changeMobileNumber(false)"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-footer">
              <button
                  class="contract-cancel-btn btn-hover"
                  @click="$router.push(contractTypesPath)"
              >
                취소
              </button>
              <button
                  class="contract-submit-btn btn-hover preview-button"
                  @click="uiHandler.handleModal.contractDraftModal.show"
              >
                미리보기
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  @click="(uiHandler.createTempContract)"
                  style="font-weight: 700;"
              >
                계약서 임시저장
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  @click="uiHandler.handleModal.summary.show"
                  style="font-weight: 700;"
              >
                계약서 작성 완료
              </button>
            </div>
          </a-col>
          <a-col></a-col>
          <a-col class="col-sm-12 col-xs-12 contract-container is-desktop-only">
            <div class="contract-title">
              {{ pageTitle }} 미리보기
              <LottieAnimation
                  v-if="previewLoading"
                  :animation-data="loadingAnimation"
                  :auto-play="true"
                  :loop="true"
                  :speed="1"
                  class="lottie-player-component loading-img"
                  ref="anim"
              />
              <a-button v-else type="primary" @click="uiHandler.makeContractDraft">
                <i class="fa-solid fa-rotate-right"></i><span style="margin-left: 5px">새로고침</span>
              </a-button>
            </div>
            <div class="iframe-wrap">
              <iframe ref="previewIframe" :src=modal.contractDraft.embeddedUrl class="preview-iframe" style="height: 1215px"></iframe>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
  <search-client-modal
      :show-modal="modal.client.show"
      @close-modal="uiHandler.handleModal.client.close"
      @complete-search="uiHandler.handleModal.client.handleEvent.selectClient"
  />
  <summary-contract-modal
      :show-modal="modal.summary.show"
      :summary-contents="summary"
      @summary-confirm="uiHandler.handleModal.summary.handleEvent.summaryConfirm"
      @close-modal="uiHandler.handleModal.summary.close"
  />
  <create-contract-success-modal-v3
      :show-modal="modal.createSuccess.show"
      :secure-link-param="secureLinkParam"
      @close-modal="uiHandler.handleModal.createSuccess.close"
  />
  <contract-draft-modal
      :show-modal="modal.contractDraft.show"
      :embedded-url="modal.contractDraft.embeddedUrl"
      @close-modal="uiHandler.handleModal.contractDraftModal.close"
  />
</template>
<script>
import {
  oneBtnDialog,
  phoneNumberFormatter,
  logging,
  businessNumberFormatter, twoBtnDialog,
} from '@/utils/utils';
import ContractItemWrap from '@/views/ContractManagement/components/ContractItemWrap.vue';
import SignModal from '@/views/ContractManagement/components/SignModal.vue';
import SearchClientModal from '@/views/ContractManagement/components/SearchClientModal.vue';
import {localStorageEnums} from "@/enums/localStorage.enums";
import SummaryContractModal from "@/views/ContractManagement/components/SummaryContractModal.vue";
import CreateContractSuccessModalV3 from "@/views/ContractManagementV3/components/CreateContractSuccessModalV3.vue";
import ContractDraftModal from "@/views/ContractManagement/components/ContractDraftModal.vue";
import {LottieAnimation} from "lottie-web-vue";
import loadingAnimation from "@/assets/img/loading.json";
// v3: contracts-api 전용 api 모듈 + axios 인스턴스 (BnkV3/MulpumV6V3 와 동일 조리법 —
// v1 공용 모달은 자체 api()에서 여전히 v1/inapi 를 쓰며 이번 범위에서 손대지 않는다).
import contractApi from "@/views/ContractManagementV3/api";
import contractsApiInstance from "@/contractsApi";
import {resolveContractCreateRouteName} from "@/views/ContractManagementV3/routeMap";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from 'dayjs';
import {ContractTypeEnum} from "@/views/ContractManagement/enums";
import {validateContractClientNameLength} from "@/views/ContractManagement/contracts/contractValidationUtils";

import { attachPrixPreviewFit } from '@/utils/prixPreviewFit';
import {CONTRACT_TYPES_PATH} from '@/utils/contractConsole';
const getDateFromEpochTime = (value) => {
  if (!value) return '';
  return dayjs(value).format('YYYY-MM-DD');
}

const getEpochTimeFromDate = (dateString) => {
  if (!dateString) return 0;
  return dayjs(dateString, 'YYYY-MM-DD');
}

export default {
  // v3 라우트 name = routeMap 단일 매핑(v1 name + 'V3'). 라우트 등록과 동일 값 보장.
  name: resolveContractCreateRouteName('신협역구매'),
  components: {
    LottieAnimation,
    ContractDraftModal,
    CreateContractSuccessModalV3,
    SummaryContractModal,
    ContractItemWrap,
    SignModal,
    SearchClientModal,
  },
  props: {
    templateId: {
      type: String,
      required: true,
    }
  },
  computed: {
  },
  data() {
    return {
      makeContractDraftDebouncing:null,
      locale,
      loadingAnimation,
      pageTitle: this.$route.query.name ?? '',
      logging,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractTypesPath: CONTRACT_TYPES_PATH,
      contractTitle: '신협 역구매 계약서',
      contractCreator: '',
      contractType: ContractTypeEnum.신협,
      validateCount: 0,
      previewLoading: false,
      directInputClientName: false,
      deptNames: [],
      modal: {
        client: {
          show: false,
        },
        sign: {
          show: false,
        },
        summary: {
          show: false,
        },
        createSuccess: {
          show: false
        },
        contractDraft: {
          embeddedUrl: '',
          show: false
        }
      },
      summary: {
        "계약명": "",
        "병원명": "",
        "병원장명": "",
        "병원 주소": "",
        "병원 연락처": "",
      },
      secureLinkParam: {
        contractId: '',
        participantId: '',
      },

      clientData: {
        companyName: '',
        address: '',
        addressDetail: '',
        cNo: '',
        ceo: {
          name: '',
          birthday: null,
        },
        contact: {
          phone: '',
          mobile: '',
          email: '',
        },
        rawHospitalData: {},
      },

      contractDate: dayjs(),
      selectedDept: null,
      personInCharge: {
        dept: '',
        name: '',
        mobile: '',
      },
      clientBirthDate: null,
    }
  },
  async mounted() {
    await this.uiHandler.getUserInfo();
    await this.uiHandler.makeContractDraft();
    await this.uiHandler.loadDeptNames();
    await this.uiHandler.loadTempContract();
    // 이벤트 리스너 등록
    window.removeEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
    window.addEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
    // 프릭스 미리보기를 컨테이너 폭에 맞춘다(창 크기 변화도 따라감).
    this.$nextTick(() => attachPrixPreviewFit(this.$refs.previewIframe));
  },
  beforeDestroy() {
    // 컴포넌트가 사라질 때 이벤트 리스너 해제
    window.removeEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
  },
  watch: {
  },
  methods: {
    twoBtnDialog,
    ui() {
      const parseClientData = (client) => {
        this.clientData.address = '';
        this.clientData.ceo.name = '';
        this.clientData.ceo.birthday = null;
        this.clientData.contact.mobile = '';
        this.clientData.contact.phone = '';
        this.personInCharge.dept = '';
        this.personInCharge.name = '';
        this.personInCharge.mobile = '';

        if (client.bizAddr || (client.addrOne && client.addrTwo && client.addrThree)) {
          this.clientData.address = client.bizAddr;
          this.$refs.address.classList.remove('error');
          document.getElementById('address-error').innerHTML = '';
        }
        if (client.ceo) {
          this.clientData.ceo.name = client.ceo;
          this.$refs.ceoName.classList.remove('error');
          document.getElementById('ceo-name-error').innerHTML = '';
        }
        if (client.ceoMobile) {
          this.clientData.contact.mobile = phoneNumberFormatter(client.ceoMobile);
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }

        if (client.empInfo) {
          if (client.empInfo.empDept) {
            this.personInCharge.dept = client.empInfo.empDept;
            this.$refs.dept.classList.remove('error');
            document.getElementById('dept-error').innerHTML = '';
          }
          if (client.empInfo.empName) {
            this.personInCharge.name = client.empInfo.empName;
            this.$refs.personInChargeName.classList.remove('error');
            document.getElementById('person-in-charge-error').innerHTML = '';
          }
          if (client.empInfo.empMobile) {
            this.personInCharge.mobile = phoneNumberFormatter(client.empInfo.empMobile);
            this.$refs.personMobileNumber.classList.remove('error');
            document.getElementById('person-in-charge-mobile-error').innerHTML = '';
          }
        }
      }

      const makeContractParam = () => {
        return {
          templateId: this.templateId,
          contractCreator: this.contractCreator,
          contractType: this.contractType,
          contractTitle: this.contractTitle,
          clientInfos: [
            {
              name: this.clientData.companyName
                  .replace('(출고정지)', '')
                  .replace('(거래중지_악성미수)', '')
                  .replace('(거래중지-영본확인)', '')
                  .replace('(거래정지)', ''),
              bizNo: this.clientData.cNo,
              address: `${this.clientData.address}`.trim(),
              manager: this.clientData.ceo.name,
              mobile: this.clientData.contact.mobile,
            }
          ],
          seller: {
            branch: this.personInCharge.dept,
            manager: this.personInCharge.name,
            mobile: this.personInCharge.mobile,
          },
          contract: {
            contractDate: getDateFromEpochTime(this.contractDate),
            clientBirthDate: this.clientBirthDate ? dayjs(this.clientBirthDate).format('YYYY년 MM월 DD일') : null
          },
        }
      }

      const createContract = async () => {
        await this.apiHandler.createContract(
          makeContractParam(),
          async (response) => {
            this.secureLinkParam = {
              contractId: response.data.id,
              participantId: response.data.participants[0]?.id,
            }
            this.uiHandler.handleModal.createSuccess.show()
          }, async (error) => {
            await oneBtnDialog('계약 추가 실패', '신규 계약서 작성에 실패하였습니다.', false);
          }
        )
      }

      const validateData = async () => {
        let isValid = true;
        // 고객 상호
        if (!this.clientData.companyName) {
          this.$refs.companyName.classList.add('error');
          document.getElementById('company-name-error').innerHTML = '고객 상호를 입력해주세요.';
          isValid = false;
        }
        // 주소
        if (!this.clientData.address) {
          this.$refs.address.classList.add('error');
          document.getElementById('address-error').innerHTML = '주소를 입력해주세요.';
          isValid = false;
        }
        // 대표자 이름
        if (!this.clientData.ceo.name) {
          this.$refs.ceoName.classList.add('error');
          document.getElementById('ceo-name-error').innerHTML = '대표자 이름을 입력해주세요.';
          isValid = false;
        }
        // 연락처
        if (!this.clientData.contact.mobile) {
          this.$refs.companyMobileNumber.classList.add('error');
          document.getElementById('mobile-error').innerHTML = '연락처를 입력해주세요.';
          isValid = false;
        }
        // 계약일
        if (!this.contractDate) {
          this.$refs.contractDate.classList.add('error');
          document.getElementById('contract-date-error').innerHTML = '계약일을 입력해주세요.';
          isValid = false;
        }
        // 영업담당자 정보
        if (!this.personInCharge.dept) {
          this.$refs.dept.classList.add('error');
          document.getElementById('dept-error').innerHTML = '지점을 입력해주세요.';
          isValid = false;
        }
        if (!this.personInCharge.name) {
          this.$refs.personInChargeName.classList.add('error');
          document.getElementById('person-in-charge-error').innerHTML = '담당자 이름을 입력해주세요.';
          isValid = false;
        }
        if (!this.personInCharge.mobile) {
          this.$refs.personMobileNumber.classList.add('error');
          document.getElementById('person-in-charge-mobile-error').innerHTML = '담당자 연락처를 입력해주세요.';
          isValid = false;
        }
        // 생년월일 검증
        if (!this.clientBirthDate) {
          this.$refs.clientBirthDate.classList.add('error');
          document.getElementById('client-birth-date-error').innerHTML = '생년월일을 선택해주세요.';
          isValid = false;
        }
        // 거래처 상호 길이 검증 (modusign metadata 80자 제한)
        const clientNameCheck = validateContractClientNameLength({
          name: this.clientData.companyName,
          manager: this.clientData.ceo.name,
          mobile: this.clientData.contact.mobile,
        });
        if (!clientNameCheck.ok) {
          this.$refs.companyName.classList.add('error');
          document.getElementById('company-name-error').innerHTML = clientNameCheck.message;
          isValid = false;
        } else if (this.clientData.companyName) {
          this.$refs.companyName?.classList.remove('error');
          const _el = document.getElementById('company-name-error');
          if (_el) _el.innerHTML = '';
        }
        return isValid;
      }

      return {
        handleModal: {
          client: {
            show: () => this.modal.client.show = true,
            close: () => this.modal.client.show = false,
            handleEvent: {
              selectClient: async (client) => {
                this.clientData.rawHospitalData = client;
                this.clientData.cNo = businessNumberFormatter(client.cNo);
                this.clientData.companyName = client.name;
                this.$refs.companyName.classList.remove('error');
                document.getElementById('company-name-error').innerHTML = '';
                parseClientData(client);
                this.modal.client.show = false;
              }
            }
          },
          summary: {
            show: async () => {
              if (!await validateData()) return;
              this.summary = {
                계약명: this.contractTitle,
                병원명: `${this.clientData.companyName} (${this.clientData.cNo ? this.clientData.cNo : '거래처 직접 입력 - 사업자등록번호 발급전 입니다.'})`,
                병원장명: this.clientData.ceo.name,
                "병원 주소": `${this.clientData.address}`,
                "병원 연락처": `(휴대전화) ${this.clientData.contact.mobile}`,
              }
              this.modal.summary.show = true
            },
            close: () => this.modal.summary.show = false,
            handleEvent: {
              summaryConfirm: async () => {
                await createContract();
              }
            }
          },
          createSuccess: {
            show: () => {
              this.modal.summary.show = false;
              this.modal.createSuccess.show = true
            },
            close: () => this.modal.createSuccess.show = false,
          },
          contractDraftModal: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              await this.uiHandler.makeContractDraft();
              this.modal.contractDraft.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: () => this.modal.contractDraft.show = false
          }
        },
        getUserInfo: () => {
          const data = JSON.parse(localStorage.getItem(localStorageEnums.CompanyInfo));
          this.contractCreator = data?.accountInfo?.username;
        },
        makeContractDraft: async () => {
          this.previewLoading = true
          // 거래처 상호 길이 가드: 미리보기/초안 자동생성 경로 (modusign metadata 80자 제한)
          // 자동 호출 경로이므로 모달 금지 — 인라인 에러 표시 후 API 호출 skip
          const _previewClientNameCheck = validateContractClientNameLength({
            name: this.clientData.companyName,
            manager: this.clientData.ceo.name,
            mobile: this.clientData.contact.mobile,
          });
          if (!_previewClientNameCheck.ok) {
            this.$refs.companyName.classList.add('error');
            document.getElementById('company-name-error').innerHTML = _previewClientNameCheck.message;
            this.previewLoading = false;
            return;
          } else if (this.clientData.companyName) {
            this.$refs.companyName?.classList.remove('error');
            const _el = document.getElementById('company-name-error');
            if (_el) _el.innerHTML = '';
          }
          await this.apiHandler.createContractDraft(
            makeContractParam(),
            async (response) => {
              this.modal.contractDraft.embeddedUrl = `${response?.data?.embeddedUrl}&mode=preview`;
            }, async (error) => {
              await oneBtnDialog('계약 초안 생성 실패', '신규 계약서 초안 생성에 실패하였습니다.', false);
            }
          ).finally(() => this.previewLoading = false)
        },
        checkScreenSizeAndFetch: async () => {
          if (this.makeContractDraftDebouncing) {
            clearTimeout(this.makeContractDraftDebouncing);
          }
          const thisObj = this;
          this.makeContractDraftDebouncing = setTimeout(async function() {
            await thisObj.uiHandler.makeContractDraft();
          },500);
        },
        loadDeptNames: async () => {
          await this.apiHandler.getDistinctDeptName({}, (deptNames) => {
            this.deptNames = deptNames;
          }, (error) => {
            console.error('Failed to load department names', error);
          });
        },
        createTempContract: async (e) => {
          const confirm = await twoBtnDialog('안내', '계약서를 임시저장 하시겠습니까?', '저장')
          if (confirm) {
            await this.apiHandler.createTempContract({
              contractType: this.contractType,
              payload: {...makeContractParam(), directInputClientName: this.directInputClientName}
            }, (response) => {
              console.log("create temp contract==>", response)
            }, (error) => {
              console.log("create temp contract==>", error)
            })
          }
        },
        loadTempContract: async () => {
          await this.apiHandler.getTempContract({
            contractType: this.contractType,
          }, async (result) => {
            const {payload} = result
            if (payload) {
              const contract = payload.contract
              const confirm = await twoBtnDialog('안내', '임시저장된 계약서 내용이 있습니다. 불러오시겠습니까?', '확인')
              if (confirm) {
                const clientInfo = payload.clientInfos[0]
                const seller = payload.seller
                // 병원정보
                this.clientData.companyName = clientInfo.name
                this.clientData.ceo.name = clientInfo.manager
                this.clientData.cNo = clientInfo.bizNo
                this.clientData.address = clientInfo.address
                this.clientData.contact.mobile = clientInfo.mobile
                this.directInputClientName = payload.directInputClientName
                // 계약담당자 정보
                this.personInCharge.mobile = seller.mobile
                this.personInCharge.dept = seller.branch
                this.selectedDept = seller.branch
                this.personInCharge.name = seller.manager
                // 계약 정보
                this.contractDate = getEpochTimeFromDate(contract.contractDate)
                this.clientBirthDate = getEpochTimeFromDate(contract.clientBirthDate)
                // 계약서 미리보기에 반영하기
                await this.uiHandler.makeContractDraft()
              }
            }
          }, (err) => {
            console.log("get temp contract error==>", err);
          })
        },
        checkDirectInputClientName: (e) => {
          // 매수인 정보 클리어
          this.clientData.companyName = ''
          this.clientData.ceo.name = ''
          this.clientData.ceo.birthday = null
          this.clientData.cNo = ''
          this.clientData.address = ''
          this.clientData.contact.mobile = ''
          // 영업담당자 정보
          this.personInCharge.name = ''
          this.personInCharge.dept = ''
          this.selectedDept = null
          this.personInCharge.mobile = ''
          // 체크박스 토글
          this.directInputClientName = e.target.checked
        },
        searchAddress: () => {
          new daum.Postcode({
            oncomplete: (data) => {
              var addr = '';
              if (data.userSelectedType === 'R') {
                addr = data.roadAddress;
              } else {
                addr = data.jibunAddress;
              }
              this.clientData.address = addr;
              if (this.clientData.address) {
                this.$refs.address.classList.remove('error');
                document.getElementById('address-error').innerHTML = '';
              }
            }
          }).open();
        },
        handleContractDate: (value) => {
          this.contractDate = value;
          this.$refs.contractDate.classList.remove('error');
          document.getElementById('contract-date-error').innerHTML = '';
        },
        changeMobileNumber: (isCeo) => {
          if (isCeo) {
            this.clientData.contact.mobile = phoneNumberFormatter(this.clientData.contact.mobile);
            this.$refs.companyMobileNumber.classList.remove('error');
            document.getElementById('mobile-error').innerHTML = '';
          } else {
            this.personInCharge.mobile = phoneNumberFormatter(this.personInCharge.mobile);
            this.$refs.personMobileNumber.classList.remove('error');
            document.getElementById('person-in-charge-mobile-error').innerHTML = '';
          }
        },
        handleRemoveError: (ref, id) => {
          if (this.$refs[ref]) {
            this.$refs[ref]?.classList.remove('error');
          } else {
            document.getElementById(ref)?.classList?.remove('error');
          }
          document.getElementById(id).innerHTML = '';
        },
        disabledFutureDate(current) {
          return current && current > dayjs().endOf('day');
        },
        handleBirthDateChange(date) {
          this.clientBirthDate = date;
          if (date) {
            this.$refs.clientBirthDate.classList.remove('error');
            document.getElementById('client-birth-date-error').innerHTML = '';
          }
        },
      }
    },
    api() {
      return contractApi(contractsApiInstance, this.$store)
    },
  }
}
</script>
<style scoped>
.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

.productRemark {
  text-align: left;
  width: 100%;
  height: 100px;
  border-radius: 8px;
  border: 1px #ced4da solid;
  resize: none;
  padding: 10px;
}

.productRemark::placeholder {
  font-size: 16px;
  color: #8D939A
}
</style>
<style scoped lang="scss">
@import '@/assets/scss/contract-detail';

// selectbox 관련
.ant-select {
  .ant-select-selection-placeholder {
    color: #000 !important;
  }

  .ant-select-selector {

    &:hover {
      border: none !important;
      border: 2px solid #1890ff !important;
    }

    &:focus {
      border: 2px solid #1890ff !important;
    }
  }
}

.custom-calendar-wrap {
  &.single {
    .ant-picker {
      width: 100%;
      height: 40px;
      
      .ant-picker-input {
        input {
          font-size: 14px;
          
          &::placeholder {
            color: #8c8c8c;
          }
        }
      }
    }
  }
}





/* [2026-08-24] 프릭스 미리보기 — 크고 선명하게. 상세 근거는 utils/prixPreviewFit.js 주석 참조.
   요지: 뷰어는 로드 시점의 iframe 폭으로 배율을 이산적으로 고른다. 1100px 로 두어야 100%(문서 약 702px)로
   그려진다. 그 문서는 컨테이너(약 673px)보다 커서 그냥 두면 양옆이 잘리므로, 컨테이너 폭에 맞춘 축소를
   attachPrixPreviewFit() 이 인라인 transform/margin-left 로 넣는다(부모 폭은 CSS 로 알 수 없다).
   1차 시도였던 scale(1.3) 확대는 픽셀을 늘리는 방식이라 흐려져 폐기했다 — 축소는 흐려지지 않는다.
   [HARD] 전역 .preview-iframe / .iframe-wrap(assets/scss/contract-detail.scss)은 V1 화면 22 개가
   공유하므로 건드리지 않는다 — scoped 선택자([data-v-*])가 우선순위에서 이겨 V3 에만 적용된다. */
.iframe-wrap {
  overflow: hidden;
}

.preview-iframe {
  width: 1100px;
  flex-shrink: 0; /* .iframe-wrap 이 flex 라 지정하지 않으면 컨테이너 폭으로 줄어든다 */
  transform-origin: top left;
}
</style>
